import { render, staticRenderFns } from "./page-view.vue?vue&type=template&id=78ee3afb&scoped=true&"
import script from "./page-view.vue?vue&type=script&lang=js&"
export * from "./page-view.vue?vue&type=script&lang=js&"
import style0 from "./page-view.vue?vue&type=style&index=0&id=78ee3afb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ee3afb",
  null
  
)

export default component.exports